var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#48b737",
    height: 440,
    rx: 56,
    width: 440,
    x: 26,
    y: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m352.6 163.76a139.849 139.849 0 0 0 -104.009-46.073c-77.172 0-139.729 62.073-139.729 138.649a137.231 137.231 0 0 0 20.038 71.587l-25.215 74.39 77.69 77.687h228.625a56 56 0 0 0 56-56v-147.045c-1.119-1.082-109.9-110.033-113.4-113.195zm-4.052 153.74a8.1 8.1 0 0 0 -.861-.808c.7-.421 1.4-.832 2.108-1.239q-.613 1.026-1.247 2.047z",
    fill: "#1a1a1a",
    opacity: 0.21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "WhatsApp",
    d: "m388.313 256.337c0 76.571-62.555 138.645-139.726 138.645a139.99 139.99 0 0 1 -67.541-17.251l-77.359 24.582 25.216-74.39a137.222 137.222 0 0 1 -20.046-71.587c0-76.576 62.557-138.649 139.729-138.649s139.727 62.074 139.727 138.65zm-139.726-116.568c-64.781 0-117.474 52.294-117.474 116.568a115.354 115.354 0 0 0 22.375 68.342l-14.673 43.286 45.143-14.348a117.415 117.415 0 0 0 64.628 19.283c64.773 0 117.475-52.289 117.475-116.563s-52.701-116.568-117.474-116.568zm70.555 148.5c-2.105-3.46-10.452-5.879-14.134-7.66-4.909-2.375-10.137-5.687-15.4-7.184-12.291-3.5-14.831 21.447-26.413 15.7-3.42-1.7-14.461-5.285-27.544-16.865-6.711-5.938-13.3-13.337-17.656-21.232-4.787-8.671 4.045-11.425 7.653-18.817 3.1-6.359-1.294-12.652-3.8-18.69-2.176-5.235-4.748-17.258-10.2-19.912-13.34-6.49-25.558 8.237-29.207 19.2-5.617 16.878 1.761 34.487 11.975 47.977 1.71 2.261 23.686 37.693 58.5 51.306 11.881 4.639 25.363 11.137 38.4 8.986a39.952 39.952 0 0 0 17.823-7.363c5.941-4.43 14.718-17.61 10.007-25.442z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon-05.9f6035f09492faad0d434c61e8ff113e.svg";
export { ForwardRef as ReactComponent };